/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! Behavioural Automation — viewer.
 *  /rules, /actions ; POST /save-rule, /toggle-rule, /delete-rule, /run.
 *  Talks through the app's GS.api ({ok,status,data}).
 */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["behavioral-automation"] = "1.0.0"; } catch (e) {}
  if (window.__bauWired) return; window.__bauWired = 1;

  var root = document.querySelector('[data-ba="root"]');
  if (!root) return;
  function q(k) { return root.querySelector('[data-ba="' + k + '"]'); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function siteParam() { return "site=" + encodeURIComponent((window.GS && GS.site) || ""); }
  function ready(fn) {
    var done = false; function go() { if (done) return; done = true; fn(); }
    document.addEventListener("gs:ready", go, { once: true });
    var n = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++n > 200) clearInterval(t); }, 30);
    if (window.GS && GS.api && GS.site) go();
  }
  function post(path, body) { return GS.api(path + "?" + siteParam(), { method: "POST", body: JSON.stringify(body || {}) }); }

  var ALERT_LABELS = {
    any: TR('behavi.g.any_alert'), rage_in_progress: TT('ba.m.rage_in_progress'), hot_lead_cooling: TT('ba.m.hot_lead_cooling'),
    hot_lead_live: TT('ba.m.hot_lead_active'), frustration_spike: TR('behavi.g.frustration_spike'), abandoning: TR('behavi.g.disengaging'), deep_engagement: "Deep engagement"
  };

  /* ---- rules ---- */
  function loadRules() {
    GS.api("/plugin/behavioral-automation/rules?" + siteParam()).then(function (r) {
      var d = (r && r.ok && r.data) || {}, host = q("rules");
      var rules = d.rules || [];
      if (!rules.length) { host.innerHTML = '<div class="ba-empty">'+TR('behavi.no_rules_yet_click')+'<b>'+TT('ba.js.new_rule')+'</b> to act on live alerts.</div>'; return; }
      host.innerHTML = rules.map(ruleCard).join("");
      Array.prototype.forEach.call(host.querySelectorAll("[data-tgl]"), function (el) {
        el.addEventListener("change", function () { post("/plugin/behavioral-automation/toggle-rule", { id: +el.getAttribute("data-tgl"), enabled: el.checked }).then(loadRules); });
      });
      Array.prototype.forEach.call(host.querySelectorAll("[data-edit]"), function (b) {
        b.addEventListener("click", function () { openEdit(rules.find(function (x) { return x.id === +b.getAttribute("data-edit"); })); });
      });
      Array.prototype.forEach.call(host.querySelectorAll("[data-del]"), function (b) {
        b.addEventListener("click", function () { if (confirm(TT('ba.x.delete_this_rule'))) post("/plugin/behavioral-automation/delete-rule", { id: +b.getAttribute("data-del") }).then(loadRules); });
      });
    });
  }
  function ruleCard(r) {
    var m = r.match || {}, cond = [];
    cond.push("<b>" + esc(ALERT_LABELS[m.alert_id] || m.alert_id || "Any") + "</b>");
    if (m.min_severity && m.min_severity !== "any") cond.push(esc(m.min_severity) + "+ sev");
    if (m.kind && m.kind !== "any") cond.push(esc(m.kind));
    if (m.page_contains) cond.push('page ~ "' + esc(m.page_contains) + '"');
    if (m.min_fire_count > 1) cond.push("&ge; " + m.min_fire_count + " fires");
    if (m.device) cond.push(esc(m.device));
    return '<div class="ba-rule' + (r.enabled ? "" : " off") + '">' +
      '<div class="ba-rule-top"><span class="ba-rule-name">' + esc(r.name) + "</span>" +
      '<span class="ba-atype ' + esc(r.action_type) + '">' + esc(r.action_type) + "</span>" +
      '<label class="ba-toggle"><input type="checkbox" data-tgl="' + r.id + '"' + (r.enabled ? " checked" : "") + '><span class="sl"></span></label></div>' +
      '<div class="ba-rule-cond">' + cond.join(" &middot; ") + "</div>" +
      '<div class="ba-rule-actions"><button class="ba-mini" data-edit="' + r.id + '">'+TR('behavi.g.edit')+'</button><button class="ba-mini del" data-del="' + r.id + '">'+TR('behavi.g.delete')+'</button></div></div>';
  }

  /* ---- actions log ---- */
  function loadActions() {
    GS.api("/plugin/behavioral-automation/actions?" + siteParam() + "&hours=24").then(function (r) {
      var d = (r && r.ok && r.data) || {}, host = q("actions");
      if (!(d.actions || []).length) { host.innerHTML = '<div class="ba-empty">No actions in the last 24 hours. Run the engine after alerts have fired.</div>'; return; }
      host.innerHTML = d.actions.map(function (a) {
        var icon = { flag: "flag", tag: "tag", webhook: "webhook", log: "journal-text" }[a.action_type] || "dot";
        return '<div class="ba-act"><span class="ic ' + esc(a.action_type) + '"><i class="bi bi-' + (icon === "flag" ? "flag-fill" : icon === "tag" ? "tag-fill" : icon === "webhook" ? "hdd-network" : "journal-text") + '"></i></span>' +
          '<span class="tx"><b>' + esc(a.rule_name || "rule") + '</b><div class="sub">' + esc(a.detail || "") + " &middot; session " + a.session_id + (a.vid ? ' &middot; <a class="ba-src" href="/realtime-alerts?id=' + encodeURIComponent(a.vid) + '">source alert</a>' : "") + "</div></span>" +
          '<span class="st ' + esc(a.status) + '">' + esc(a.status) + "</span></div>";
      }).join("");
    });
  }

  /* ---- run ---- */
  function run() {
    var rr = q("runresult"); rr.hidden = false; rr.innerHTML = TT('ba.a.running_hellip');
    post("/plugin/behavioral-automation/run", {}).then(function (r) {
      var d = (r && r.ok && r.data) || {};
      if (d.note && !d.actions_new) { rr.innerHTML = esc(d.note); }
      else {
        var bt = d.by_type || {};
        rr.innerHTML = "Evaluated <b>" + (d.rules_evaluated || 0) + "</b> rule(s) over <b>" + (d.alerts_scanned || 0) +
          "</b> alert(s) &rarr; <b>" + (d.actions_new || 0) + "</b> new action(s)" +
          " (flag " + (bt.flag || 0) + ", tag " + (bt.tag || 0) + ", webhook " + (bt.webhook || 0) + ", log " + (bt.log || 0) + ").";
      }
      loadActions();
    }).catch(function () { rr.innerHTML = TT('ba.a.run_failed'); });
  }

  /* ---- builder modal ---- */
  function openNew() { fill({ id: 0, name: "", enabled: true, action_type: "flag", match: {}, action: {} }); q("modal-title").textContent = TT('ba.a.new_rule'); q("modal").hidden = false; }
  function openEdit(r) { if (!r) return; fill(r); q("modal-title").textContent = TT('ba.a.edit_rule'); q("modal").hidden = false; }
  function closeModal() { q("modal").hidden = true; }
  function fill(r) {
    var m = r.match || {}, a = r.action || {};
    q("f-id").value = r.id || 0; q("f-name").value = r.name || "";
    q("f-alert").value = m.alert_id || "any"; q("f-sev").value = m.min_severity || "any";
    q("f-kind").value = m.kind || "any"; q("f-fire").value = m.min_fire_count || 1;
    q("f-page").value = m.page_contains || ""; q("f-device").value = m.device || "";
    q("f-action").value = r.action_type || "flag"; q("f-enabled").checked = r.enabled !== false;
    syncCfg(a);
  }
  function syncCfg(a) {
    a = a || {};
    var type = q("f-action").value, lbl = q("f-cfg-lbl"), inp = q("f-cfg");
    if (type === "flag") { lbl.textContent = TT('ba.a.flag_label'); inp.placeholder = "flagged"; inp.value = a.label || ""; }
    else if (type === "tag") { lbl.textContent = "Tag"; inp.placeholder = "hot-lead"; inp.value = a.tag || ""; }
    else if (type === "webhook") { lbl.textContent = TT('ba.a.webhook_url'); inp.placeholder = "https://…"; inp.value = a.webhook_url || ""; }
    else { lbl.textContent = "—"; inp.placeholder = "no config"; inp.value = ""; inp.disabled = true; return; }
    inp.disabled = false;
  }
  function save() {
    var type = q("f-action").value, cfg = {};
    var v = q("f-cfg").value.trim();
    if (type === "flag") cfg.label = v || "flagged";
    else if (type === "tag") cfg.tag = v || "tagged";
    else if (type === "webhook") cfg.webhook_url = v;
    var body = {
      id: +q("f-id").value || 0, name: q("f-name").value.trim(), enabled: q("f-enabled").checked,
      action_type: type, action: cfg,
      match: { alert_id: q("f-alert").value, min_severity: q("f-sev").value, kind: q("f-kind").value,
               min_fire_count: +q("f-fire").value || 1, page_contains: q("f-page").value.trim(), device: q("f-device").value }
    };
    post("/plugin/behavioral-automation/save-rule", body).then(function () { closeModal(); loadRules(); });
  }

  function prefillFromURL() {
    var p; try { p = new URLSearchParams(location.search); } catch (e) { return; }
    if (p.get("new") !== "1" && !p.get("alert") && !p.get("sev")) return;
    fill({
      id: 0, name: p.get("name") ? "Auto: " + p.get("name") : "", enabled: true, action_type: "flag",
      match: {
        alert_id: p.get("alert") || "any", min_severity: p.get("sev") || "any", kind: p.get("kind") || "any",
        page_contains: p.get("page") || "", device: p.get("device") || ""
      },
      action: {}
    });
    q("modal-title").textContent = TT('ba.a.new_rule');
    q("modal").hidden = false;
  }

  ready(function () {
    q("run").addEventListener("click", run);
    q("new").addEventListener("click", openNew);
    q("close").addEventListener("click", closeModal);
    q("cancel").addEventListener("click", closeModal);
    q("save").addEventListener("click", save);
    q("f-action").addEventListener("change", function () { syncCfg({}); });
    loadRules(); loadActions();
    prefillFromURL();
  });
})();
